import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    Row,
    Col,
    FormGroup,
    Input,
    Label
} from 'design-react-kit';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
        };
    };

    handleSearchChange(e) {
        this.setState({ searchTerm: e.target.value });
    };

    handleClick(uid, search_query, currentlyChecked) {
        const { history } = this.props;
        const currentUrl = new URL(window.location.href);
        if (currentlyChecked) {
            currentUrl.searchParams.delete('indexChainBelongs');
        } else {
            currentUrl.searchParams.set('indexChainBelongs', uid);
            currentUrl.searchParams.set('SearchableText', search_query);
        }

        history.push(currentUrl.pathname + currentUrl.search);
    };

    render() {
        const { items, search_query, checked, intl } = this.props;
        const { searchTerm } = this.state;
        if (!items?.items || items.items.length < 0) {
            return null;
        }
        const afferenze = items['afferenze'] || {};
        const filteredAfferenze = Object.entries(afferenze).filter(([key]) => {
            if (key === 'non definito') return false;
            const [, title] = key.split('|');
            return title.toLowerCase().includes(searchTerm.toLowerCase());
        });

        return (
            <UncontrolledDropdown nav tag="div" className="resultSearchFilter">
                <DropdownToggle
                    aria-haspopup
                    caret
                    color="black"
                    nav
                    style={{ fontSize: '1.5rem', color: 'black' }}
                >
                    {intl.formatMessage({ id: 'filtraRisultatiLabel' })}
                    <Icon color="black" icon="it-expand" padding={false} size="" />
                </DropdownToggle>
                <DropdownMenu
                    flip
                    tag="div"
                    style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        padding: '1rem',
                        overflowX: 'hidden'
                    }}
                >
                    {/* Barra di ricerca */}
                    <div
                        style={{
                            position: 'sticky',
                            top: 0,
                            backgroundColor: 'white',
                            zIndex: 1,
                            padding: '0.5rem',
                            borderBottom: '1px solid #ccc',
                        }}
                        className='searchbar shadow-sm d-flex w-100'
                    >
                        <Icon
                            icon="it-search"
                            padding={false}
                            size="md"
                            aria-hidden="true"
                            className="mx-3 mt-2"
                        />
                        <Input
                            type="text"
                            placeholder={intl.formatMessage(
                                { id: 'searchInStrutture' }
                            )}
                            value={searchTerm}
                            onChange={(e) => this.handleSearchChange(e)}
                        />
                    </div>

                    {/* Lista delle afferenze */}
                    {filteredAfferenze.map(([key, count]) => {
                        const [uid, title] = key.split('|');
                        return (
                            <Row tag="div" key={uid}>
                                <Col
                                    tag="div"
                                    widths={['xs', 'sm', 'md', 'lg', 'xl']}
                                >
                                    <FormGroup check inline>
                                        <Input
                                            id={`checkbox-${uid}`}
                                            type="checkbox"
                                            checked={checked}
                                            onChange={
                                                () => this.handleClick(uid,search_query,checked)
                                            }
                                        />
                                        <Label
                                            check
                                            for={`checkbox-${uid}`}
                                        >
                                            {`${title} (${count})`}
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        );
                    })}
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }
}

Filter.propTypes = {
    items: PropTypes.object.isRequired,
    search_query: PropTypes.string,
    checked: PropTypes.bool,
};

export default connect()(
    injectIntl(withRouter(Filter)),
);